import { render, staticRenderFns } from "./postEdit.vue?vue&type=template&id=0b46cea9"
import script from "./postEdit.vue?vue&type=script&lang=js"
export * from "./postEdit.vue?vue&type=script&lang=js"
import style0 from "./postEdit.vue?vue&type=style&index=0&id=0b46cea9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports